import _isEmpty from 'lodash/isEmpty';

import {
  VIEW_TEMPLATE_MODE,
  APPLY_TEMPLATE_MODE,
  EDIT_TEMPLATE_MODE,
  CREATE_TEMPLATE_MODE,
} from 'components/modules/theme-templates/constants';

export function getThemeTemplateModalMode({
  templateToView,
  templateToApply,
  templateToEdit,
  websiteTemplateToCreate,
  createBlankTemplateModalOpen,
}) {
  if (!_isEmpty(templateToView)) {
    return VIEW_TEMPLATE_MODE;
  }

  if (!_isEmpty(templateToApply)) {
    return APPLY_TEMPLATE_MODE;
  }

  if (!_isEmpty(templateToEdit)) {
    return EDIT_TEMPLATE_MODE;
  }

  if (!_isEmpty(websiteTemplateToCreate)) {
    return CREATE_TEMPLATE_MODE;
  }

  if (createBlankTemplateModalOpen) {
    return CREATE_TEMPLATE_MODE;
  }

  return VIEW_TEMPLATE_MODE;
}
